<template lang="html">
  <span class="p-1">
    <b-tooltip
      v-if="isTeacher"
      label="Unfollow Teacher"
      type="is-dark-orange"
      position="is-left"
    >
      <b-button class="is-dark-orange is-inverted" @click="removeTeacher">
        <b-icon icon="eye-minus-outline"></b-icon> </b-button
    ></b-tooltip>
    <b-tooltip v-else label="Follow Teacher" type="is-dark-orange" position="is-left">
      <b-button class="is-dark-orange" @click="addTeacher">
        <b-icon icon="eye-plus-outline"></b-icon> </b-button
    ></b-tooltip>
  </span>
</template>

<script>
export default {
  props: ['teacher', 'user'],
  data () {
    return {
      isTeacher: false
    }
  },
  created () {
    this.fetchStatus()
  },
  methods: {
    fetchStatus () {
      this.$store
        .dispatch('users/teachers/show', {
          user: this.user,
          teacher: this.teacher.username
        })
        .then((resp) => {
          this.isTeacher = Object.keys(resp.data).length !== 0
        })
        .catch((_) => {})
    },
    removeTeacher () {
      this.$store
        .dispatch('users/teachers/destroy', {
          user: this.user,
          teacher: this.teacher.username
        })
        .then((resp) => {
          this.$buefy.toast.open({
            message: `You are no longer a student of ${this.teacher.cosplayer_name}`,
            type: 'is-success'
          })
          this.isTeacher = false
        })
        .catch((_) => {})
    },
    addTeacher () {
      this.$store
        .dispatch('users/teachers/create', {
          user: this.user,
          teacher: this.teacher.username
        })
        .then((resp) => {
          this.$buefy.toast.open({
            message: `You are now a student of ${this.teacher.cosplayer_name}`,
            type: 'is-success'
          })
          this.isTeacher = true
        })
        .catch((_) => {})
    }
  }
}
</script>

<style lang="css" scoped></style>
